import React from "react";

import BookingRequestRowCard from "./bookingrequest";
import { Panel } from "components/panels";
import { useCustomQuery, useManualPagination } from "utilities/hookutils";

interface Props {
  config: server.dto.DashboardBookingRequestPanelConfig
}

const bookkeepingRequestsQueryKey = "bookingRequests";

const BookingRequestsPanel = (props: Props) => {
  const perPage = 10;
  const pagination = useManualPagination(1, perPage, () => { });

  const query = useCustomQuery({
    queryFn: async () => window.CoreApi.Dashboard.ShowsFromWebform(pagination.page, perPage).then(r => r.data),
    queryKey: [bookkeepingRequestsQueryKey, {
      page: pagination.page,
      perPage
    }],
    keepPreviousData: true,
    onSuccess: (data) => { pagination.setPagination(data.pagination); }
  });

  return (
    <Panel
      title={props.config.headerLabel}
      articleId={serverReference.supportArticleIds.bookingRequests}
      panelClassName="s1_dashboard-panel"
      pagination={pagination.Component}
      isLoading={query.isLoading}
      hasData={query.data?.data.length > 0}
      hasError={query.isError}
    >
      <div className="list-with-gaps line-layout">
        <div className="list-with-gaps-body">
          {query.data?.data.map((bookingRequest) => (
            <BookingRequestRowCard key={bookingRequest.showId} bookingRequest={bookingRequest} />
          ))}
        </div>
      </div>
    </Panel>
  );
};

export default BookingRequestsPanel;
